<template>
  <div class="row mt-2 mb-3">
    <div class="col-5 order-setupitem-title-area">
      <h4>{{title}}</h4>
      <div v-if="userHasUpdatePermission(permissionType)" class="order-setupitem-details">
        <div v-for="(approvalRequestReason, index) in approvalRequestReasonList" :key="index">
          <template v-if="isAccountApprovalType">
            <Icon iconStyle="far" icon="fa-credit-card" iconClass="status-credit-danger" class="mr-1" fixedWidth></Icon>
            {{approvalRequestReason}}
          </template>
        </div>
      </div>
    </div>
    <div class="col-6">
      <template v-if="getApprovalStatusForType() == ApprovalTypes.pending && isStatusPending">
        <div v-if="userHasUpdatePermission(permissionType) && approvalEnabled">
          <ProgressTrackerButton @click="$emit('approve')" icon="fa-thumbs-up">{{approveButtonTitle}}</ProgressTrackerButton>
          &nbsp;&nbsp;
          <ProgressTrackerButton @click="$emit('deny')" icon="fa-thumbs-down">{{denyButtonTitle}}</ProgressTrackerButton>
        </div>
        <div class="mt-1" v-if="!userHasUpdatePermission(permissionType) && approvalEnabled">
          <p class="font-weight-bold">Approval required</p>
        </div>        
        <slot name="pending" />
      </template>
      <div v-if="isApprovalTypeApproved()">
        <p class="order-setupitem-result status-approved"><i class="far fa-check-circle"></i> Approved</p>
        <div v-if="approvedNote" class="order-setupitem-notes" v-html="convertNewlinesToBreaks(approvedNote)"></div>
        <FileAttachment v-for="file in attachedFileList" :key="file.id" :file="file" />
        <p>Approved by {{approvalUserName}} at {{approvalDate | formatDateTime}}</p>
        <slot name="approved" />
      </div>
      <div v-if="isApprovalTypeDenied()">
        <p class="order-setupitem-result status-denied"><i class="far fa-times-circle"></i> Denied</p>
        <div v-if="deniedReason" class="order-setupitem-notes" v-html="convertNewlinesToBreaks(deniedReason)"></div>
        <FileAttachment v-for="file in attachedFileList" :key="file.id" :file="file" />
        <p>Denied by {{approvalUserName}} at {{approvalDate | formatDateTime}}</p>
        
        <slot name="denied" />
      </div>
    </div>
    <div class="col-1"> </div>
  </div>
</template>

<script>
import ProgressTrackerButton from '@/components/layout/progressTrackerButton.vue'
import { ApprovalTypes, TaskApprovalTypes, TaskStatusTypes } from '@/store/types'

export default {
  name: 'TaskApprovalBar',
  components: {
    ProgressTrackerButton
  },
  props: {
    title: String,
    approvalType: String,
    approvalEnabled: {
      type: Boolean,
      default: true
    },
    permissionType: String,
    task: Object,
    approveButtonTitle: {
      type: String,
      default: 'Approve'
    },
    denyButtonTitle: {
      type: String,
      default: 'Deny'
    }
  },
  created() {
    this.ApprovalTypes = ApprovalTypes
    this.TaskApprovalTypes = TaskApprovalTypes
  },
  computed: {
    approvalUserName() {
      let approval = this.getApprovalInfoForType()
      if(approval && approval.user)
        return approval.user.name
      return ''
    },
    approvalDate() {
      let approval = this.getApprovalInfoForType()
      if(approval)
        return approval.approvalUpdatedDate
      return ''
    },
    approvalRequestReasonList() {
      let approval = this.getApprovalInfoForType()
      if(approval)
        return approval.requestReason.split('\n')
      return []
    },
    approvedNote() {
      let approval = this.getApprovalInfoForType()
      if(approval)
        return approval.approvedNote
      return ''
    },
    deniedReason() {
      let approval = this.getApprovalInfoForType()
      if(approval) {
        var deniedReason = ''
        deniedReason += approval.deniedReason

        return deniedReason
      }
      return ''
    },
    attachedFileList() {
      let approval = this.getApprovalInfoForType()
      if(approval)
        return approval.userFiles || []
      return []
    },
    isStatusPending() {
      return this.task.status == TaskStatusTypes.pendingApproval
    },
    isAccountApprovalType() {
      return this.approvalType == TaskApprovalTypes.account
    },
  },
  methods: {
    getApprovalInfoForType() {
      if(!this.task || !this.task.taskApprovals)
        return null
      return this.task.taskApprovals.find(app => app.type == this.approvalType)
    },
    getApprovalStatusForType() {
      let info = this.getApprovalInfoForType()
      if(info == null)
        return ApprovalTypes.pending
      return info.approvalStatus
    },
    isApprovalTypeApproved() {
      return this.getApprovalStatusForType() == ApprovalTypes.approved
    },
    isApprovalTypeDenied() {
      return this.getApprovalStatusForType() == ApprovalTypes.denied
    },
    clickedApprovalReason(event) {
      this.$emit('displayDetails', event)
    }
  }
}
</script>